import React, { useState, useCallback, useRef, useEffect } from "react";
import logo from "../../../assets/images/coinlogo.png";
import "./games2048.css";
import cancelbtn from "../../../assets/Task/cancelicon1.png";
import cancelIcon from "../../../assets/Task/cancelicon.svg";
import useUserInfo from "../../../Hooks/useUserInfo";
import questionMarkIcon from "../../../assets/Task/ReferImg.png";
import { userGameRewards, getUserDetails1 } from "../../../apis/user";
import { useAudio } from "../../../Providers/AudioProvider";
import task from "../../Task/Task";
import Swal from "sweetalert2";
import { logPageView } from "../../../components/analytics";
import GameLeaderboard from "../leaderboard/gameleader";
const Dark2048 = () => {
  const { userDetails, updateUserInfo, watchScreen, updatewatchScreenInfo } =
    useUserInfo();
  const userId = userDetails?.userDetails?.telegramId;
  const [board, setBoard] = useState(() => initializeBoard());
  const [score, setScore] = useState(0);
  const [finalScore, setFinalScore] = useState(0);
  const [highScore, setHighScore] = useState(() => {
    try {
      const stored = localStorage.getItem("2048HighScore");
      return stored ? Number(stored) : 0;
    } catch (error) {
      console.warn("Failed to load high score from localStorage:", error);
      return 0;
    }
  });
  const [apiHighScore, setApiHighScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [mouseStart, setMouseStart] = useState(null);
  const [mouseEnd, setMouseEnd] = useState(null);
  const [apiCallMade, setApiCallMade] = useState(false);
  const playClick = useAudio();
  const scrollableRef = useRef(null);
  const IsPointsReached =
    watchScreen?.LoginMessage ==
    "You have already reached the maximum rewards limit"
      ? true
      : false;
  useEffect(() => {
    const preventTouchScroll = (event) => {
      // Allow scrolling only for the scrollable div
      if (!scrollableRef.current.contains(event.target)) {
        event.preventDefault();
      }
    };
    // Add the event listener
    document.addEventListener("touchmove", preventTouchScroll, {
      passive: false,
    });
    // Cleanup the event listener
    return () => {
      document.removeEventListener("touchmove", preventTouchScroll);
    };
  }, []);

  useEffect(() => {
    logPageView("game2048 ", "game 2048");
  }, []);

  // Fetch initial high score from API on component mount
  useEffect(() => {
    const fetchInitialHighScore = async () => {
      try {
        const res = await getUserDetails1();
        if (
          res &&
          res.user &&
          res.user.gameRewards &&
          res.user.gameRewards.games
        ) {
          const game2048 = res.user.gameRewards.games.find(
            (game) => game.gameType === "2048F"
          );
          if (game2048 && game2048.highScore) {
            setApiHighScore(game2048.highScore);
            // Update local high score if API high score is higher
            if (game2048.highScore > highScore) {
              setHighScore(game2048.highScore);
              localStorage.setItem(
                "2048HighScore",
                game2048.highScore.toString()
              );
            }
          }
        }
      } catch (error) {
        console.error("Failed to fetch initial high score:", error);
      }
    };

    fetchInitialHighScore();
  }, []);
  // Initialize board
  function initializeBoard() {
    const newBoard = Array(4)
      .fill()
      .map(() => Array(4).fill(0));
    return addRandomTile(addRandomTile(newBoard));
  }
  function addRandomTile(board) {
    const emptyCells = [];
    board.forEach((row, i) => {
      row.forEach((cell, j) => {
        if (cell === 0) emptyCells.push([i, j]);
      });
    });
    if (emptyCells.length === 0) return board;
    const [row, col] =
      emptyCells[Math.floor(Math.random() * emptyCells.length)];
    const newBoard = board.map((row) => [...row]);
    newBoard[row][col] = Math.random() < 0.9 ? 2 : 4;
    return newBoard;
  }
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart({
      x: e.targetTouches[0].clientX,
      y: e.targetTouches[0].clientY,
    });
  };
  const onTouchMove = (e) => {
    setTouchEnd({
      x: e.targetTouches[0].clientX,
      y: e.targetTouches[0].clientY,
    });
  };
  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const minSwipeDistance = 30;
    const deltaX = touchEnd.x - touchStart.x;
    const deltaY = touchEnd.y - touchStart.y;
    const absDeltaX = Math.abs(deltaX);
    const absDeltaY = Math.abs(deltaY);
    if (Math.max(absDeltaX, absDeltaY) > minSwipeDistance) {
      if (absDeltaX > absDeltaY) {
        if (deltaX > 0) {
          move("right");
        } else {
          move("left");
        }
      } else {
        if (deltaY > 0) {
          move("down");
        } else {
          move("up");
        }
      }
    }
    setTouchStart(null);
    setTouchEnd(null);
  };

  // Mouse event handlers for desktop
  const onMouseDown = (e) => {
    setMouseEnd(null);
    setMouseStart({
      x: e.clientX,
      y: e.clientY,
    });
  };

  const onMouseMove = (e) => {
    setMouseEnd({
      x: e.clientX,
      y: e.clientY,
    });
  };

  const onMouseUp = () => {
    if (!mouseStart || !mouseEnd) return;
    const minSwipeDistance = 30;
    const deltaX = mouseEnd.x - mouseStart.x;
    const deltaY = mouseEnd.y - mouseStart.y;
    const absDeltaX = Math.abs(deltaX);
    const absDeltaY = Math.abs(deltaY);
    if (Math.max(absDeltaX, absDeltaY) > minSwipeDistance) {
      if (absDeltaX > absDeltaY) {
        if (deltaX > 0) {
          move("right");
        } else {
          move("left");
        }
      } else {
        if (deltaY > 0) {
          move("down");
        } else {
          move("up");
        }
      }
    }
    setMouseStart(null);
    setMouseEnd(null);
  };
  const mergeLine = (line) => {
    let merged = line.filter((num) => num !== 0);
    let scoreIncrease = 0; // Track score increase locally
    for (let i = 0; i < merged.length - 1; i++) {
      if (merged[i] === merged[i + 1]) {
        merged[i] *= 2;
        scoreIncrease += merged[i]; // Add to local score
        merged.splice(i + 1, 1);
      }
    }
    while (merged.length < 4) merged.push(0);
    if (scoreIncrease > 0) {
      setScore((prev) => prev + scoreIncrease); // Update score after merging
    }
    return { merged, scoreIncrease };
  };
  const move = useCallback(
    (direction) => {
      if (gameOver) return;
      let newBoard = board.map((row) => [...row]);
      let moved = false;
      let totalScoreIncrease = 0;
      switch (direction) {
        case "left":
          newBoard = newBoard.map((row) => {
            const result = mergeLine([...row]);
            if (JSON.stringify(result.merged) !== JSON.stringify(row))
              moved = true;
            totalScoreIncrease += result.scoreIncrease;
            return result.merged;
          });
          break;
        case "right":
          newBoard = newBoard.map((row) => {
            const result = mergeLine([...row].reverse());
            const merged = result.merged.reverse();
            if (JSON.stringify(merged) !== JSON.stringify(row)) moved = true;
            totalScoreIncrease += result.scoreIncrease;
            return merged;
          });
          break;
        case "up":
          for (let col = 0; col < 4; col++) {
            const column = newBoard.map((row) => row[col]);
            const result = mergeLine(column);
            if (JSON.stringify(result.merged) !== JSON.stringify(column))
              moved = true;
            totalScoreIncrease += result.scoreIncrease;
            result.merged.forEach((val, row) => (newBoard[row][col] = val));
          }
          break;
        case "down":
          for (let col = 0; col < 4; col++) {
            const column = newBoard.map((row) => row[col]).reverse();
            const result = mergeLine(column);
            const merged = result.merged.reverse();
            if (JSON.stringify(merged) !== JSON.stringify(column.reverse()))
              moved = true;
            totalScoreIncrease += result.scoreIncrease;
            merged.forEach((val, row) => (newBoard[row][col] = val));
          }
          break;
        default:
          return;
      }
      if (moved) {
        newBoard = addRandomTile(newBoard);
        setBoard(newBoard);
        // Calculate the current score including the increase
        const currentScore = score + totalScoreIncrease;
        checkGameOver(newBoard, currentScore);
      }
    },
    [board, gameOver, score]
  );

  // Add keyboard support for desktop
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (gameOver) return;
      
      switch (event.key) {
        case "ArrowUp":
          event.preventDefault();
          move("up");
          break;
        case "ArrowDown":
          event.preventDefault();
          move("down");
          break;
        case "ArrowLeft":
          event.preventDefault();
          move("left");
          break;
        case "ArrowRight":
          event.preventDefault();
          move("right");
          break;
        case "w":
        case "W":
          event.preventDefault();
          move("up");
          break;
        case "s":
        case "S":
          event.preventDefault();
          move("down");
          break;
        case "a":
        case "A":
          event.preventDefault();
          move("left");
          break;
        case "d":
        case "D":
          event.preventDefault();
          move("right");
          break;
        default:
          break;
      }
    };

    // Add keyboard event listener
    document.addEventListener("keydown", handleKeyPress);
    
    // Cleanup the event listener
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [gameOver, move]);

  const handleApiResponse = async (points) => {
    if (apiCallMade || points <= 0) {
      return;
    }

    setApiCallMade(true);
    setFinalScore(points);

    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));

    try {
      const apiData = {
        gamePoints: points,
        gameType: "2048F",
      };
      const res = await userGameRewards(apiData);
      if (res) {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));

        // Extract high score from API response
        const game2048 = res?.user?.gameRewards?.games?.find(
          (game) => game.gameType === "2048F"
        );
        if (game2048 && game2048.highScore) {
          setApiHighScore(game2048.highScore);
          // Update local high score if API high score is higher
          if (game2048.highScore > highScore) {
            setHighScore(game2048.highScore);
            localStorage.setItem(
              "2048HighScore",
              game2048.highScore.toString()
            );
          }
        }

        setGameOver(true);
      }
    } catch (error) {
      console.error("API call failed:", error);
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
      // Still show game over even if API fails
      setGameOver(true);
    }
  };
  const checkGameOver = (currentBoard, currentScore) => {
    // Check if any moves are possible
    for (let i = 0; i < 4; i++) {
      for (let j = 0; j < 4; j++) {
        if (currentBoard[i][j] === 0) return;
      }
    }
    for (let i = 0; i < 4; i++) {
      for (let j = 0; j < 3; j++) {
        if (currentBoard[i][j] === currentBoard[i][j + 1]) return;
        if (currentBoard[j][i] === currentBoard[j + 1][i]) return;
      }
    }
    // Update high score if current score is higher
    try {
      const currentHighScore = Math.max(highScore, apiHighScore);
      if (currentScore > currentHighScore) {
        const newHighScore = currentScore;
        setHighScore(newHighScore);
        localStorage.setItem("2048HighScore", newHighScore.toString());
        console.log(`New high score achieved: ${newHighScore}`);
      }
    } catch (error) {
      console.warn("Failed to update high score:", error);
    }

    // Only call handleApiResponse when game is actually over
    // Use the currentScore parameter instead of state
    setTimeout(() => {
      handleApiResponse(currentScore);
    }, 100);
  };
  // Dark theme tile colors
  const getTileColor = (value) => {
    const colors = {
      0: "bg-dark border border-secondary",
      2: "bg-secondary text-light",
      4: "bg-info bg-opacity-75 text-dark",
      8: "bg-primary text-white",
      16: "bg-primary bg-opacity-75 text-white",
      32: "bg-success bg-opacity-75 text-white",
      64: "bg-success text-white",
      128: "bg-warning bg-opacity-75 text-white",
      256: "bg-warning text-white",
      512: "bg-danger bg-opacity-75 text-white",
      1024: "bg-danger text-white",
      2048: "bg-danger bg-gradient text-white",
    };
    return colors[value] || "bg-danger text-white";
  };
  const getTextSize = (value) => {
    if (value >= 1000) return "fs-5";
    return "fs-4";
  };
  // Custom styles for tile glow effects
  const tileStyle = (value) => {
    if (value >= 128) {
      return {
        boxShadow: "0 0 10px rgba(255, 193, 7, 0.5)",
      };
    } else if (value >= 32) {
      return {
        boxShadow: "0 0 7px rgba(40, 167, 69, 0.5)",
      };
    } else if (value >= 8) {
      return {
        boxShadow: "0 0 5px rgba(13, 110, 253, 0.5)",
      };
    }
    return {};
  };
  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };
  const closePopUp = () => {
    setBoard(initializeBoard()); // Reset the board
    setScore(0); // Reset the score
    setFinalScore(0); // Reset the final score
    setGameOver(false); // Hide the popup
    setApiCallMade(false); // Reset API call flag
  };
  const goToThePage = (component, name) => {
    updateUserInfo((prev) => ({
      ...prev,
      currentComponent: component,
      currentComponentText: name,
      lastComponent: userDetails.currentComponent,
      lastComponentText: userDetails.currentComponentText,
      centerCount: userDetails.centerCount + 1,
      isMenu: false,
    }));
  };

  const ExitGame = () => {
    if (score > 0 && !apiCallMade) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to exit the game?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Exit",
        reverseButtons: true, // Puts "Exit" on the left and "Continue" on the right
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("User chose to continue");
          // Add logic for continuing the game
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          // Use current score and ensure API call is made
          handleApiResponse(score);
        }
      });
    }
  };
  return (
    <div className="container-fluid game-container vh-100 d-flex align-items-center justify-content-center bg-black p-3">
      <img
        onClick={() => {
          toogleMenu(task, "task");
        }}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-full "
        style={{ cursor: "pointer" }}
      />
      <img
        onClick={() => {
          goToThePage(GameLeaderboard, "2048F");
        }}
        src={questionMarkIcon}
        alt="Question Mark Icon"
        className="cancel-full-lead"
        style={{ marginLeft: "5px" }}
      />
      <div className="row w-100" style={{ maxWidth: "500px" }}>
        <div className="col-12 p-2">
          {/* Header */}
          <div className="align-items-center ">
            <h1 className="display-6 mb-0 text-light text-center  text-uppercase welcometextmeme">
              2048 Game
            </h1>
            <div className="row flex">
              <div className="col-6 text-center">
                <div class="bg-gray-800 green text-green-400 px-3 py-2 rounded-full font-bold text-uppercase">
                  {IsPointsReached ? "Score" : "Tokens"} : {score}
                </div>
              </div>
              {/* <div className="col-6 text-center">
                <div class="bg-gray-800 yellow text-yellow-400 px-3 py-2 rounded-full font-bold text-uppercase">
                  High Score : {Math.max(highScore, apiHighScore)}
                </div>
              </div> */}
            </div>
          </div>
          {/* Game Board */}
          <div className="w-100 mb-2">
            <div
              className="bg-dark bg-opacity-75 p-2 rounded border border-secondary"
              style={{
                touchAction: "none",
                aspectRatio: "1",
                boxShadow: "0 0 20px rgba(33, 37, 41, 0.5)",
                outline: "none",
                userSelect: "none",
              }}
              tabIndex={0}
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
              onMouseDown={onMouseDown}
              onMouseMove={onMouseMove}
              onMouseUp={onMouseUp}
              onKeyDown={(e) => {
                // Focus the game board when clicked
                e.currentTarget.focus();
              }}
            >
              {board.map((row, i) => (
                <div key={i} className="row h-25 m-0">
                  {row.map((cell, j) => (
                    <div key={`${i}-${j}`} className="col-3 h-100 p-1">
                      <div
                        className={`${getTileColor(cell)} ${getTextSize(cell)} 
                          rounded h-100 d-flex align-items-center justify-content-center 
                          fw-bold`}
                        style={{
                          transition: "all 0.15s ease-in-out",
                          ...tileStyle(cell),
                        }}
                      >
                        {cell !== 0 && cell}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
          {gameOver && (
            <div className="overlay">
              <div className="full-popup">
                <div className="popup-content">
                  <h2 className="epic">Game Over!</h2>
                  <img
                    src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                    className="cancel-img"
                    onClick={closePopUp}
                  />
                  {!IsPointsReached ? (
                    <div className="row text-center">
                      <div className="col-12">
                        <div
                          className="epic-div"
                          style={{ padding: "30px 40px" }}
                        >
                          <p className="pointsLabel">TOKENS EARNED</p>
                          <div className="pointsValue1">
                            <img src={logo} alt="logo" />
                            <p className="pointsNumber">
                              {finalScore || score}
                            </p>
                          </div>
                        </div>
                        <p className="bottom-text">
                          Play daily to boost your score and rack up more
                          points!
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="row text-center">
                      <div className="col-12">
                        <div className="epic-div">
                          <p
                            className="pointsLabel"
                            style={{
                              fontSize: "18px",
                              fontWeight: "bold",
                              margin: "20px 0",
                              textAlign: "center",
                            }}
                          >
                            POINTS EARNED: {finalScore || score} <br />
                            TOKENS EARNED: NIL
                          </p>
                        </div>
                        <p className="bottom-text">
                          Keep sliding! 🎮 Rack up points and chase the high
                          score!
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {/* <button
            onClick={() => {
              setBoard(initializeBoard());
              setScore(0);
              setGameOver(false);
            }}
            className="btn btn-secondary w-100 p-3 fs-5 mb-2 shadow"
          >
            New Game
          </button> */}
          <div className="text-center text-light medium text-uppercase">
            Swipe, drag with mouse, or use arrow keys (↑↓←→) or WASD to move tiles
          </div>
          <div className="row flex">
            <div className="col-6">
              <button className="ext-btn text-uppercase" onClick={ExitGame}>
                {" "}
                Quit Game
              </button>
            </div>
          </div>
        </div>
      </div>
      <div ref={scrollableRef}></div>
    </div>
  );
};
export default Dark2048;
